<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.txtkeyVal"  placeholder="项目名称/项目编号" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <el-input v-model="pgData.xmzbrname"  placeholder="招标人" clearable></el-input>
            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler">添加招标项目</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="招标项目名称" prop="zbproname" min-width="160" fixed="left"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode" min-width="100"></el-table-column>
            <el-table-column label="招标人" prop="xmzbrname" width="180"></el-table-column>
            <el-table-column label="招标方式" prop="zbfsname" width="120"></el-table-column>
            <el-table-column label="招标组织形式" prop="zbzzxsname" width="140"></el-table-column>
            <el-table-column label="交易中心" width="220">
                <template slot-scope="scope">
                    <jyzx-state :data="scope.row"></jyzx-state>

                    <push-type 
                        :column="scope.row" 
                        :pushPage="'zbxm'" 
                        :primaryKey="scope.row.zbprocode"
                        :procode="scope.row.by1">
                    </push-type>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="160" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        style="display:inline"
                        :config="BTN_CONF">
                    </btn-list>
                    <btn-elec-agree :listType="listTypeVal" :row="scope.row"></btn-elec-agree>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/revision/Zbdl/ZbProject/get_list.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import BTN_CONF from './config/btn-list'
import JyzxState from '@views/bidding/components/jyzx-state'
import BtnElecAgree from '@views/bidding/elec-agreement/components/btn'

import PushType from '@/components-sys/push-type'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {BtnElecAgree,PushType,JyzxState},
    data() {
        return{
            pgData: {
                id:'id',
                txtkey:'',
                xmzbrname: '',
                sortname:'zbprocode',
                pagesize: 15,
                txtkeyVal:'',
            },
            

            BTN_CONF,
            listTypeVal:'jsgc',
        }
    },
    computed: {
        
    },
    watch: {
        'pgData.txtkeyVal':function(o,n){
            this.pgData.txtkey =escape(o)
        }
    },
    methods: {
        addHandler(){
            this.gotoFrame({
                title:'修改招标项目',
                url:'/Zbdl/ZbProject/edit',
            })
        },
        
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
